import { useSearchParams } from "react-router";
import { isValidAppRoute } from "../lib";

type TrackParamsResult = { hasTrackParams: boolean; trackParams: Record<string, string> };

const ALL_TRACK_PARAMS = ["gxtm_source", "gxtm_page", "gxtm_type", "ref"];

export const useTrackParams = (): TrackParamsResult => {
  const [searchParams] = useSearchParams();
  const redirectSearchParams = (() => {
    const redirectParam = searchParams.get("redirect");
    if (!redirectParam) {
      return {};
    }
    const decodedRedirect = decodeURI(redirectParam);
    if (!(isValidAppRoute(decodedRedirect) && decodedRedirect.includes("?"))) {
      return {};
    }
    const decodedRedirectSearch = decodedRedirect.split("?")[1];
    return Object.fromEntries(new URLSearchParams(decodedRedirectSearch));
  })();
  const trackParams = ALL_TRACK_PARAMS.reduce((acc, x: string) => {
    const value = searchParams.get(x) || redirectSearchParams[x];
    if (Boolean(value)) {
      acc[x] = value;
    }
    return acc;
  }, {} as Record<string, string>);

  return {
    hasTrackParams: Object.keys(trackParams).length > 0,
    trackParams
  };
};
